import React from 'react';
type TopoLinesProps = {
  className?: string;
};

/**
 * Motivo de fondo DPS65: sol + módulo fotovoltaico en línea plana (estilo
 * unifilar). Se mantiene el nombre del componente del molde. Hereda el color
 * via `currentColor`.
 */
export function TopoLines({
  className
}: TopoLinesProps) {
  return <svg viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className} data-id="element-405" data-mp="2yqzpvg5xamsh">
      {/* sol */}
      <circle cx="62" cy="58" r="20" data-id="element-406" data-mp="3qi5ry257euke" />
      <path d="M62 22v10M62 84v10M26 58h10M88 58h10M37 33l7 7M80 76l7 7M37 83l7-7M80 40l7-7" data-id="element-407" data-mp="3cjfuumidwuw1" />
      {/* módulo en perspectiva */}
      <path d="M70 214L112 112h112l-42 102z" data-id="element-408" data-mp="3hh7phoaeyv3x" />
      <path d="M84 180h112M98 146h112" data-id="element-409" data-mp="3hk3n1bicnhru" />
      <path d="M107 214l28-102M144 214l28-102" data-id="element-410" data-mp="213r6prte9ptn" />
      {/* rayos al módulo */}
      <path d="M86 74l30 30M74 90l22 22" strokeDasharray="3 6" data-id="element-411" data-mp="262u5iuis6zt6" />
    </svg>;
}